module.exports = __webpack_public_path__ + "img/basicConfig.960d3abe.svg";